import React, { useEffect, useRef } from 'react';
import './styles.scss';

export interface IChild {
    name: string;
    path?: string;
    icon?: string;
    handler?: Function;
}

interface IArgs {
    submenus?: Array<IChild>;
    dropdown: boolean;
    handlerChange?: Function;
    handlerItemChange?: Function;
    showSelected?: boolean;
    showSelectedIcon?: boolean;
    defaultSelected?: string;
    children?: any;
    right?: string;
    ref?: any;
}

const Dropdown = ({ dropdown, handlerChange, children }: IArgs) => {
    const ref: any = useRef(null);
    const onMouseEnter = () => {
        // eslint-disable-next-line no-magic-numbers
        window.innerWidth > 960 && handlerChange && handlerChange(true);
    };

    const onMouseLeave = () => {
        // eslint-disable-next-line no-magic-numbers
        window.innerWidth > 960 && handlerChange && handlerChange(false);
    };

    useEffect(() => {
        const handler = (event: any) => {
            if (
                dropdown &&
                ref.current &&
                !ref.current.contains(event.target)
            ) {
                if (handlerChange) handlerChange(false);
            }
        };
        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [dropdown]);

    return (
        <ul
            className={`dropdown-menu-table ${dropdown ? 'show' : ''}`}
            ref={ref}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </ul>
    );
};

export default Dropdown;
